import { Component, Input, inject } from '@angular/core';
import {IonicModule} from "@ionic/angular";
import {SharedModalControllerService} from "@shared/services/shared-modal-controller.service";


import { KnowledgeArticleDto } from '@server-models';
import {
  SharedKnowledgeArticleDetailComponent
} from '@shared/components/knowledge/components/knowledge-article-detail/shared-knowledge-article-detail.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-viewer-knowledge-article',
  templateUrl: './shared-viewer-knowledge-article.component.html',
  styleUrls: ['./shared-viewer-knowledge-article.component.scss'],
  imports: [
    IonicModule,
    SharedKnowledgeArticleDetailComponent,
    TranslatePipe
  ],
  standalone: true,
})
export class SharedViewerKnowledgeArticleComponent {
  private _modalCtrlService = inject(SharedModalControllerService);

  @Input() article!: KnowledgeArticleDto;

  exit(): void {
    this._modalCtrlService.closeModal();
  }
}
